import { gql } from "@apollo/client";

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on Address {
    fullAddress
    latitude
    longitude
    id
    mapboxId
    street
    house
    countryCode
  }
`;
